import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import MedicalRecordFormBase from "./MedicalRecordFormBase";
import type { MedicalRecord } from "../../types";

const RecordRegistration: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (
    data: MedicalRecord,
    prescriptionFile?: File | null,
    resultFile?: File | null
  ) => {
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      await axiosInstance.post(API_ENDPOINTS.MEDICAL_RECORDS.CREATE, data);

      if (prescriptionFile || resultFile) {
        console.warn("File uploads are not yet supported in this registration form due to backend limitations.");
      }
      setTimeout(() => navigate("/doctor/dashboard/record"), 1500);
    } catch (error) {
      console.error("Error creating medical record:", error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <MedicalRecordFormBase
        mode="create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default RecordRegistration;
